import { render, staticRenderFns } from "./KMProfileDetail.vue?vue&type=template&id=03c4c9ca"
import script from "./KMProfileDetail.vue?vue&type=script&lang=js"
export * from "./KMProfileDetail.vue?vue&type=script&lang=js"
import style0 from "./KMProfileDetail.vue?vue&type=style&index=0&id=03c4c9ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports